<template>
  <el-dialog
    :append-to-body="true"
    :title="title"
    :visible.sync="dialogForm.visible"
    :close-on-click-modal="false"
    :modal-append-to-body="false"
    @open="openDialog"
    width="40%"
    v-dialogDrag
  >
    <el-form label-width="100px" :model="form" :rules="rules" ref="form">
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item label="代码" prop="code">
            <el-input
              v-model="form.code"
              clearable
              size="small"
              placeholder="请输入"
              :disabled="title === '查看'"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="名称" prop="name">
            <el-input
              v-model="form.name"
              clearable
              size="small"
              placeholder="请输入"
              :disabled="title === '查看'"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="标准">
            <el-select
              v-model="form.standardId"
              clearable
              size="small"
              placeholder="请选择标准"
              class="w-full"
              :disabled="title === '查看'"
            >
              <el-option
                v-for="item in standardList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="订阅类型" prop="subscribeType">
            <el-select
              v-model="form.subscribeType"
              clearable
              size="small"
              placeholder="请选择订阅类型"
              class="w-full"
              :disabled="title === '查看'"
            >
              <el-option
                v-for="(item, index) in subscribeTypeList"
                :key="index"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="备注">
            <el-input
              type="textarea"
              v-model="form.remark"
              clearable
              size="small"
              placeholder="请输入"
              :disabled="title === '查看'"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row>
      <el-select
        v-model="queryForm.classId"
        filterable
        clearable
        placeholder="实体类型"
        size="small"
        class="w-200px mr-10px"
      >
        <el-option
          v-for="item in classTypeList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
      <el-input
        v-model="queryForm.keyword"
        clearable
        size="small"
        placeholder="请输入名称/代码"
        class="w-200px mr-10px"
      ></el-input>
      <el-button type="primary" @click="searchClassData">搜索</el-button>
      <el-button type="primary" @click="handleAdd" v-if="title !== '查看'">添加</el-button>
      <el-button type="danger" @click="deleteData" v-if="title !== '查看'">删除</el-button>
    </el-row>
    <el-table
      class="mt-20px"
      border
      :data="tableData"
      :highlight-current-row="true"
      @selection-change="handleSelectionChange"
      height="300px"
      row-key="id || classId"
      ref="tableData"
    >
      <el-table-column type="selection" width="55" reserve-selection></el-table-column>
      <el-table-column label="序号" type="index" width="55"></el-table-column>
      <el-table-column label="实体类型" prop="cateName" show-overflow-tooltip>
        <template slot-scope="scope">
          <div>
            {{ scope.row.cateName ? scope.row.cateName : scope.row.stdClassTypeAttributeCateName }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="类别名称" prop="name" show-overflow-tooltip> </el-table-column>
    </el-table>
    <div class="h-48px">
      <el-pagination
        class="mt-20px float-right"
        background
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        :current-page.sync="page.pageNo"
        :page-size="page.pageSize"
        :page-sizes="$pageSizeAll"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page.total"
      ></el-pagination>
    </div>
    <div slot="footer" class="dialog-footer tc" v-if="title !== '查看'">
      <el-button type="primary" @click="save">{{ $t('save') }}</el-button>
      <el-button @click="dialogForm.visible = false">{{ $t('cancel') }}</el-button>
    </div>

    <!-- 添加订阅 -->
    <el-dialog
      :append-to-body="true"
      title="添加订阅"
      :visible.sync="showAdd"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      width="40%"
      v-dialogDrag
    >
      <el-row>
        <el-select
          v-model="query.classId"
          filterable
          clearable
          size="small"
          placeholder="请选择实体类型"
          class="w-200px mr-10px"
        >
          <el-option
            v-for="item in classTypeList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-input
          v-model="query.keyword"
          clearable
          size="small"
          placeholder="请输入类别名称/代码"
          class="w-200px mr-10px"
        ></el-input>
        <el-button type="primary" @click="getClassData">搜索</el-button>
      </el-row>
      <el-table
        class="mt-20px"
        border
        :data="classData"
        :highlight-current-row="true"
        @selection-change="handleSelectionClass"
        height="300px"
        row-key="id"
        ref="classData"
      >
        <el-table-column type="selection" width="55" reserve-selection></el-table-column>
        <el-table-column label="序号" type="index" width="55"></el-table-column>
        <el-table-column label="实体类型" prop="stdClassTypeAttributeCateName"> </el-table-column>
        <el-table-column label="类别名称" prop="name"> </el-table-column>
      </el-table>
      <div class="h-48px">
        <el-pagination
          class="mt-20px float-right"
          background
          @current-change="handleCurrentClass"
          @size-change="handleSizeClass"
          :current-page.sync="classPage.pageNo"
          :page-size="classPage.pageSize"
          :page-sizes="$pageSizeAll"
          layout="total, sizes, prev, pager, next, jumper"
          :total="classPage.total"
        ></el-pagination>
      </div>
      <div slot="footer" class="dialog-footer tc">
        <el-button type="primary" @click="addClass">{{ $t('save') }}</el-button>
        <el-button @click="showAdd = false">{{ $t('cancel') }}</el-button>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
import SubscribePublishService from '@/services/SubscribePublishService'
import EntityTypeService from '@/services/EntityTypeService'
import StdClassTreeService from '@/services/bsApi/StdClassTreeService'
import stdClassListService from '@/services/stdClassListService'

export default {
  props: ['dialogForm'],
  data() {
    return {
      standardList: localStorage.getItem('standardList')
        ? JSON.parse(localStorage.getItem('standardList'))
        : [],
      classTypeList: [],
      subscribeTypeList: [
        { name: '全量订阅', value: 0 },
        { name: '变化订阅', value: 1 },
      ],
      form: {
        code: '',
        name: '',
        standardId: localStorage.getItem('standardId'),
        remark: '',
        subscribeType: null,
      },
      queryForm: {
        classId: '',
        keyword: '',
      },
      rules: {},
      keyword: '',
      tableData: [],
      selectionList: [],
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      showAdd: false,
      query: {
        classId: '',
        keyword: '',
      },
      classData: [],
      classSelection: [],
      classPage: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      title: '',
    }
  },
  watch: {
    'form.standardId': {
      handler(newVal) {
        if (newVal) {
          this.getClassTypeList()
        }
      },
    },
  },
  created() {
    this.rules = {
      code: [{ required: true, message: this.$t('pleaseEnterCode'), trigger: 'blur' }],
      name: [{ required: true, message: this.$t('pleaseEnterTheName'), trigger: 'blur' }],
      subscribeType: [{ required: true, message: '请选择订阅类型', trigger: 'blur' }],
    }
  },
  methods: {
    openDialog() {
      this.queryForm = this.$options.data().queryForm
      if (this.dialogForm.type === 'add') {
        this.title = '新增'
        this.form = this.$options.data().form
        this.tableData = []
        this.dialogForm.id = null
      } else if (this.dialogForm.type === 'update') {
        this.title = '编辑'
      } else {
        this.title = '查看'
      }
      this.getClassTypeList()
      this.getDetail()
      this.searchTableData()
    },
    handleSelectionChange(val) {
      this.selectionList = val
    },
    handleCurrentChange(num) {
      this.page.pageNo = num
      this.searchTableData()
    },
    handleSizeChange(size) {
      this.page.pageSize = size
      this.searchTableData()
    },
    searchClassData() {
      if (this.dialogForm.type === 'add') {
        this.$message.warning('请先保存')
        return
      }
      this.searchTableData()
    },
    async searchTableData() {
      if (!this.dialogForm.id) return
      const res = await SubscribePublishService.subscribeClassPagedResult({
        CateId: this.queryForm.classId,
        Id: this.dialogForm.id,
        Filter: this.queryForm.keyword,
        SkipCount: (this.page.pageNo - 1) * this.page.pageSize,
        MaxResultCount: this.page.pageSize,
      })
      if (res && res.code === 0) {
        this.tableData = res.data
        this.page.total = res.totalCount
      }
    },
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const params = { ...this.form }
          const classIds = this.tableData.map((item) => {
            return item.id || item.classId
          })
          params.classIdList = classIds
          if (this.dialogForm.id) {
            // 修改
            this.updateSubscribeApply(params)
          } else {
            // 新增
            this.addSubscribeApply(params)
          }
        }
      })
    },
    // 新增订阅发布
    async addSubscribeApply(params) {
      const res = await SubscribePublishService.addSubscribeApply(params)
      if (res && res.code === 0) {
        this.$message.success('新增成功')
        this.dialogForm.visible = false
        this.$emit('refresh')
      }
    },
    // 编辑订阅发布
    async updateSubscribeApply(params) {
      const res = await SubscribePublishService.updateSubscribeApply(this.dialogForm.id, params)
      if (res && res.code === 0) {
        this.$message.success('修改成功')
        this.dialogForm.visible = false
        this.$emit('refresh')
      }
    },
    handleSelectionClass(val) {
      this.classSelection = val
    },
    handleCurrentClass(num) {
      this.classPage.pageNo = num
      this.getClassData()
    },
    handleSizeClass(size) {
      this.classPage.pageSize = size
      this.getClassData()
    },
    addClass() {
      if (this.classSelection.length === 0) {
        this.$message.info('请选择你要添加的数据')
        return
      }
      const arr = []
      const flagArr = []
      this.tableData.forEach((item) => {
        arr.push(item.id || item.classId)
      })
      this.classSelection.forEach((val) => {
        const check = val.id
        if (_.includes(arr, check)) {
          flagArr.push(false)
        } else {
          flagArr.push(true)
        }
      })
      // 从新勾选的项和这边表格已选项是否有重叠的
      if (_.every(flagArr, Boolean)) {
        this.tableData = this.classSelection.concat(this.tableData)
        this.showAdd = false
      } else {
        this.$message.warning('该数据已添加')
      }
    },
    // 实体类型下拉列表数据
    async getClassTypeList() {
      const parameter = {
        data_type: 1,
        is_type: true,
        approve_status: 1,
        standard_id: this.form.standardId,
      }
      const res = await StdClassTreeService.getTreeList(parameter)
      if (res && res.code === 0 && res.data) {
        this.classTypeList = res.data
      }
      // const res = await EntityTypeService.getEntityTypeList({
      //   StandardId: this.form.standardId,
      //   Filter: '',
      //   Sorting: '',
      //   SkipCount: 0,
      //   MaxResultCount: 999,
      // })
      // if (res && res.code === 0) {
      //   this.classTypeList = _.filter(res.data, (item) => {
      //     return item.approveStatus === 1
      //   })
      // }
    },
    // 查询实体
    async getClassData() {
      const res = await stdClassListService.getClassList({
        standard_id: this.form.standardId,
        pageno: this.classPage.pageNo,
        pagesize: this.classPage.pageSize,
        data_type: 1,
        std_class_type_attribute_cate_id: this.query.classId,
        keyword: this.query.keyword,
      })
      if (res && res.code === 0) {
        this.classData = res.data
        this.classPage.total = res.page.recordCount
        this.classSelection = []
        this.$nextTick(() => {
          this.$refs.classData.clearSelection()
        })
      }
    },
    // 添加
    handleAdd() {
      this.showAdd = true
      this.getClassData()
    },
    deleteData() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择要删除的数据')
        return
      }
      this.tableData = this.tableData.filter((item) => {
        return !this.selectionList.includes(item)
      })
      this.page.total = this.tableData.length
      this.selectionList = []
      this.$refs.tableData.clearSelection()
    },
    // 获取详情
    async getDetail() {
      if (!this.dialogForm.id) return
      const res = await SubscribePublishService.readSubscribeApply(this.dialogForm.id)
      if (res && res.code === 0) {
        this.form = res.data
      }
    },
  },
}
</script>
